import {
  Box,
  Button,
  CardMedia,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  Badge,
  Tooltip,
  Typography,
  Theme,
  TextField,
  useTheme,
  TablePagination,
  CircularProgress,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  ApplicationStatusBasedOnRole,
  APPLICATION_LISTING_STATUS,
  APPLICATION_STATUS,
  IndividualApplicationStatusBasedOnRole,
  POA_APPLICATION_STATUS,
  REJECTED_ROLES,
  USER_ROLES,
  applicantStatusMasters,
  MPOWER_ACCOUNT_TYPE_MASTER,
} from '../../utils/constant';
import {
  checkIfApplicationIsNonIndividual,
  getFirstHolderName,
  maskInfo,
} from '../../utils/utilityFunctions';
import {
  ApplicationProps,
  investmentDetailsAplicationRef,
  ResubmitFatcaResponseBody,
  UpdateChequeStatusResponseBody,
} from '../../redux-store/types/api-types';
import { useDispatch, useSelector } from 'react-redux';
import { getAllApplications, resubmitFatca, updateChequeStatus } from '../../redux-store/actions/application';
import { GetAllApplicantionsResponseBody } from '../../redux-store/types/application';
import { CommonLayout, Footer } from '../commonComponents';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import { ColumnType, DataTable } from '../DataTable';
import { useDebounce } from '../../utils/useDebounce';
import { RootStateType } from '../../redux-store/reducers';
import CloseIcon from '@mui/icons-material/Close';
import { formatShortDateAndTime } from '../../utils/date';
import { ApplicationRefs } from '../../redux-store/actions/onBoarding';
import { FilterDropdown, initialFilters } from '../investors/filters';
import {
  Distributor,
  getDistributorsList,
  getDistributorsListForFilters,
  getRMsList,
} from '../../redux-store/actions';
import { ApplicationFilterType, RMType } from '../../redux-store/types/api-types';
import { SearchIcon } from '../customSVGs';
import { FilterIcon, InfoIconOutlined, RefreshIcon } from '../../assets/SvgIcons';
import dayjs from '../../utils/dayjs';
import { showError } from '../../redux-store/actions/auth';
import {
  ChatBubbleOutline,
  Autorenew
} from '@mui/icons-material';
import {
  Form,
  Formik
} from '../../lib/formik/Formik';
import * as yup from 'yup';
import MFCheckbox from '../../lib/formik/Checkbox';
import { MFTextField } from '../../lib/formik';
import { LoadingButton } from '@mui/lab';

const statusMap: { [key: string]: string } = {
  pending: 'BSE Client Activation Pending',
  active: 'BSE Client Activated',
  failed: 'BSE Client Activation Failed',
}

const getBseClientActivationStatusMsg = (value: string): string => {
  if (!['pending', 'active', 'failed'].includes(value)) {
    return value
  } else {
    return statusMap[value]
  }
}

const getTableHeader = (role: string): ColumnType[] => {
  return [
    {
      header: 'Investor Name',
      valueGetter: (row: ApplicationProps) =>
        row?.onboardingType?.toLowerCase() === 'minor'
          ? !(row?.applicants[0]?.minorFirstName) ? "N/A"
            :
            `${row?.applicants[0]?.minorFirstName ?? ""} ${row?.applicants[0]?.minorLastName ?? ""}`
          : (getFirstHolderName(row?.applicants)) || 'N/A',

    },
    {
      header: 'Application ID',
      label: 'applicationNumber',
    },
    {
      header: 'Client Code',
      valueGetter: (row: ApplicationProps) =>
        row?.clientCode || 'N/A',

    },
    {
      header: 'Account Type',
      valueGetter: (row: ApplicationProps) => (
        <Typography variant='subtitle_500'>
          {MPOWER_ACCOUNT_TYPE_MASTER[row?.accountType] ?? 'N/A'}
        </Typography>
      ),
    },
    {
      header: 'Mode of Holding / Status',
      renderCell: (row: ApplicationProps) => {
        return (
          <Typography
            variant='subtitle_500'
            sx={{ textTransform: 'capitalize', }}
          >
            {row.modeOfHolding || 'Single'} / {
              row?.applicants?.[0]?.status ?
                applicantStatusMasters[row.applicants[0].status] ?
                  applicantStatusMasters[row.applicants[0].status] : row.applicants[0].status
                : "N/A"
            }
          </Typography>
        );
      },
    },
    // {
    //   header: 'Commited Value',
    //   valueGetter: (row: ApplicationProps) => row.commitmentAmount || 'N/A',
    // },
    {
      header: 'Investor PAN',
      valueGetter: ({ applicants = [] }: ApplicationProps) => (
        <Typography variant='subtitle_500'>
          {applicants[0]?.panNo || 'N/A'}
        </Typography>
      ),
    },
    {
      header: 'Investor Email ID',
      valueGetter: ({ applicants = [] }: ApplicationProps) => (
        <Typography variant='subtitle_500'>
          {maskInfo(applicants[0]?.email ?? '') || 'N/A'}
        </Typography>
      ),
    },
    {
      header: 'RM Name',
      valueGetter: (row: ApplicationProps) => (
        <Typography variant='subtitle_500'>
          {row?.rm?.name || 'N/A'}
        </Typography>
      ),
    },
    // {
    //   header: 'Distributor Name',
    //   label: 'viewDistributorRM',
    //   valueGetter: (row: ApplicationProps) =>
    //     row.distributor?.name || row.distributor?.arnCode || 'N/A',
    // },
    {
      header: 'Approval Status',
      renderCell: (row: ApplicationProps) => {
        const applicationStatus = row.hasPOA
          ? ApplicationStatusBasedOnRole[role][row.status]
          : checkIfApplicationIsNonIndividual(row)
            ? ApplicationStatusBasedOnRole[role][row.status]
            : !checkIfApplicationIsNonIndividual(row) && role === USER_ROLES.AMCAPPROVER
              ? IndividualApplicationStatusBasedOnRole[role][row.status]
              : APPLICATION_LISTING_STATUS[row.status];
        return (
          <Typography
            className={applicationStatus}
            sx={(theme: Theme) => ({
              textDecoration: 'none',
              ...theme.typography.subtitle_500,
              color: '#B78813',
              '&.Draft': {
                color: 'rgba(51, 127, 201, 0.7)',
              },
              '&.Completed': {
                fontWeight: 600,
                color: 'rgba(35, 133, 63, 0.7)',
              },
              '&.Rejected': {
                color: '#BD2932 !important',
                fontWeight: 500,
              },
            })}
            component={RouterLink}
            to={`/application-details/${row.id}`}>
            {applicationStatus}
          </Typography>
        );
      },
    },
    // BSE STAR STATUS Start
    {
      header: 'BSE STAR STATUS',
      valueGetter: (row: ApplicationProps) => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            variant='subtitle_500'
          >
            {row?.isBSEEnabled
              ? row?.bseClientActivationStatus
                ? getBseClientActivationStatusMsg(row?.bseClientActivationStatus)
                : 'N/A'
              : 'BSE Disabled'
            }
          </Typography>
          <Tooltip
            slotProps={{
              tooltip: {
                sx: {
                  margin: "0px !important",
                  backgroundColor: "transparent"
                }
              }
            }}
            title={
              <Box sx={{
                borderRadius: '10px',
                backgroundColor: '#0F131F',
                padding: '10px',
                display: 'flex',
                flexDirection: 'column',
                rowGap: '10px'  // Gap between each section
              }}>
                <Box>
                  <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                    STATUS
                  </Typography>
                  <Typography variant='subtitle_600'>
                    {row?.bseStarServiceResponse || '-'}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                    CLIENT CREATION RESPONSE
                  </Typography>
                  <Typography variant='subtitle_600'>
                    {row?.bseStarResponse || '-'}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                    FATCA RESPONSE
                  </Typography>
                  <Typography variant='subtitle_600'>
                    {row?.bseFatcaResponse || '-'}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                    CHEQUE UPLOAD RESPONSE
                  </Typography>
                  <Typography variant='subtitle_600'>
                    {row?.cancelChequeUploadResponse || '-'}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                    AOF IMAGE RESPONSE
                  </Typography>
                  <Typography variant='subtitle_600'>
                    {row?.bseAofImageResponse || '-'}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                    MPOWER STATUS
                  </Typography>
                  <Typography variant='subtitle_600'>
                    {row?.mpowerResponse || '-'}
                  </Typography>
                </Box>
              </Box>
            }
          >
            <IconButton>
              <InfoIconOutlined />
            </IconButton>
          </Tooltip>
        </Box>
      )
    },
    // BSE STAR STATUS End
  ];
};

export function ApplicationsListView({
  tableHeaders,
}: {
  tableHeaders: ColumnType[];
}): JSX.Element {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [applicationsList, setApplicationsList] = useState<ApplicationProps[]>([]);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { palette } = useTheme();
  const {
    page,
    search: storeSearch,
    status: storeStatus,
    applicationType: storeApplicationType,
    modeOfHolding: storeModeOfHolding,
    distributorId: storeDistributorId,
    diy: storeDIY,
    accountType: storeAccountType,
    onboardingType: storeOnboardingType,
  } = useSelector((store: RootStateType) => store.paramsObj);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState<boolean>(false);
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const [filters, setFilters] = useState<ApplicationFilterType>(
    initialFilters(role, storeStatus, storeApplicationType, storeModeOfHolding, storeDistributorId, storeDIY, storeAccountType, storeOnboardingType)
  );
  const { applicationType, distributorId, status, modeOfHolding, diy, accountType, onboardingType } = filters;
  // const [noOfPages, setNoPages] = useState(1);
  // const [currentPage, setPage] = useState(page);
  const [search, setSearch] = useState(storeSearch);
  const [noOfPages, setNoPages] = useState(1);
  const [currentPage, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0)
  const [limit, setLimit] = useState(10);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const debounceSearchString = useDebounce(search, 500);
  const [distributorLoading, setDistributorLoading] = useState(false);
  const [totalFilters, setTotalFilters] = useState<number>(0);

  useEffect(() => {
    let componentIsAlive = true;
    setLoading(true);
    setApplicationsList([]);
    (async function () {
      try {
        const response = (await dispatch(
          getAllApplications({
            page: currentPage,
            search,
            applicationType: applicationType.toString(),
            distributorId: distributorId.toString(),
            status: status.toString(),
            modeOfHolding: modeOfHolding.toString(),
            onboardingType: onboardingType?.toString(),
            diy: diy?.toString(),
            accountType: accountType?.toString(),
          })
        )) as unknown as GetAllApplicantionsResponseBody;
        const { applications, pages, total, limit } = response || {};
        if (!componentIsAlive) {
          return;
        }
        setApplicationsList(applications);
        setNoPages(pages);
        setTotalCount(total)
        setLimit(limit);
        setLoading(false);
        if (response) {
          const totalAppliedFilters = (applicationType?.length || 0) + (modeOfHolding?.length || 0) + (status?.length || 0) + (distributorId?.length || 0) + (diy?.length || 0) + (accountType?.length || 0) + (onboardingType?.length || 0);
          setTotalFilters(totalAppliedFilters);
        }
      } catch (e) {
        console.error((e as Error).message);
        setLoading(false);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, [currentPage, debounceSearchString, filters]);

  // useEffect(() => {
  //   setPage(page);
  // }, [debounceSearchString]);

  const handleFiltersAnchorEl = async () => {
    try {
      setFiltersAnchorEl(true);
      setDistributorLoading(true);
      const distributorList = (await dispatch(
        getDistributorsListForFilters()
      )) as unknown as Distributor[];
      setDistributors(distributorList);
      setDistributorLoading(false);
    } catch (e) {
      console.error((e as Error).message);
      setDistributorLoading(false);
    }
  };

  const handleFiltersAnchorElClose = () => {
    setFiltersAnchorEl(false);
  };
  const filterOptions = (totalFilters: number, setTotalFilters: React.Dispatch<React.SetStateAction<number>>): JSX.Element => {
    const badgeCount = ['applicationType', 'modeOfHolding', 'status', 'distributorId', 'diy', 'accountType', 'onboardingType'].filter(
      (filterKey) => (filters[filterKey] as string[]).length
    ).length;
    return (
      <>
        {/* <IconButton
          sx={{ p: 0.5 }}
          id="filter-icon-button"
          aria-controls="filter-menu"
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleFiltersAnchorEl}>
          <Badge badgeContent={badgeCount} color="info">
            <CardMedia component="img" image="/images/filter-icon.svg" alt="Filter Icon" />
          </Badge>
        </IconButton>{' '} */}
        <Button
          variant="text"
          startIcon={
            <Badge
              showZero
              badgeContent={totalFilters}
              sx={(theme: Theme) => ({
                '& .MuiBadge-badge': {
                  right: 0,
                  top: -3,
                  backgroundColor: theme.palette.primary[500],
                  color: theme.palette.common.white,
                  ...theme.typography.subtitle_600
                },
              })}
            >
              <FilterIcon style={{ opacity: isLoading ? 0.5 : 1 }} />
            </Badge>
          }
          sx={(theme: Theme) => ({
            color: theme.palette.text.primary,
            padding: "5px",
            ...theme.typography.body_500,
            "&:hover": {
              backgroundColor: theme.palette.grey[50]
            }
          })}
          TouchRippleProps={{
            style: {
              color: palette.grey[300]
            }
          }}
          onClick={handleFiltersAnchorEl}
          disabled={isLoading}
        >
          Filters
        </Button>
        {filtersAnchorEl && (
          <FilterDropdown
            filters={filters}
            onFiltersChange={(value) => {
              setPage(1);
              setFilters(value);
            }}
            anchorEl={filtersAnchorEl}
            handleClose={handleFiltersAnchorElClose}
            distributors={distributors}
            loader={distributorLoading}
            setTotalFilters={setTotalFilters}
          />
        )}
      </>
    );
  };

  const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    // <Box
    //   sx={{
    //     ml: { xs: 0 },
    //     p: { xs: 2, md: '50px' },
    //     borderRadius: '50px 0 0 0',
    //     bgcolor: { xs: '', md: 'rgba(238, 244, 251, 0.5)' },
    //     // minHeight: 'calc(100vh - 108px)',
    //   }}>
    <Box>
      <Box sx={{ marginBottom: '20px' }}>
        <Typography sx={{ color: 'text.primary' }} variant='h1'>
          All Applications
        </Typography>

      </Box>
      <Box style={{ background: palette.background.paper, borderRadius: '25px', overflow: 'hidden' }}>
        <Grid
          container
          sx={{
            p: '20px 30px',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            bgcolor: 'common.white',
            mb: 1.5,
          }}
          rowGap={1.5}>
          <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2 }}>
            <Grid item>
              <FormControl variant="standard" sx={{ display: 'block' }}>
                {/* <InputLabel
                  htmlFor="input-with-icon-adornment"
                  sx={{ '&.Mui-focused': { color: 'text.primary' } }}>
                  Search Application
                </InputLabel>
                <Input
                  id="input-with-icon-adornment"
                  value={search}
                  onChange={({ target: { value } }) => {
                    setPage(1);
                    setSearch(value);
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton>
                        <SearchSharpIcon sx={{ color: 'primary.main' }} />
                      </IconButton>
                    </InputAdornment>
                  }
                /> */}
                <TextField
                  id="outlined-multiline-flexible"
                  value={search}
                  placeholder={`Search  Application`}

                  onChange={({ target: { value } }) => {
                    setPage(1);
                    setSearch(value);
                  }}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    style: {
                      borderRadius: '5px',
                      // border: `1px solid ${palette.text.secondary}B2`,
                      height: '40px',
                      width: '100%',
                      maxWidth: '255px',
                      fontSize: '16px',
                    },
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid item sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}>
            {/* <FilterMenu /> */}
            {filterOptions(totalFilters, setTotalFilters)}
          </Grid>
        </Grid>
        <DataTable
          isLoading={isLoading}
          tableHeader={tableHeaders}
          tableData={applicationsList}
          // noOfPages={noOfPages}
          // currentPage={currentPage}
          // paginationAction={handlePageChange}
          // rowCustomStyles={{
          //   '&:last-child td, &:last-child th': { border: 0 },
          //   '.MuiTableCell-body ': { color: '#686e72' },
          //   background: 'transparent',
          // }}
          rowCustomStyles={{
            '&:last-child td, &:last-child th': { border: 0 },
            '.MuiTableCell-body ': { color: palette.text.primary, fontWeight: 500 },
            background: 'transparent',
          }}
          boxStyles={{ minWidth: 100 }}
        />
        <TablePagination
          style={{
            color: palette.text.primary[500],
            fontSize: 16,
            fontWeight: 500,
            padding: '20px 35px 35px 35px',
            // paddingLeft: '50px',
            // paddingBottom: '48px'
          }}
          rowsPerPageOptions={[]}
          labelRowsPerPage=""
          component="div"
          count={totalCount}
          rowsPerPage={limit}
          page={currentPage - 1}
          onPageChange={(event, num) => setPage(num + 1)}
          // onRowsPerPageChange={(rowsPerPage) => console.log('rowsPerPage', rowsPerPage.target.value)}
          sx={{
            color: palette.text.primary[500]
          }} />
      </Box>
    </Box>
  );
}

interface ChequeUploadFormValues {
  isSubmitted: boolean;
  comment: string;
}

const chequeUploadFormInitialValues: ChequeUploadFormValues = {
  isSubmitted: false,
  comment: ""
}

const chequeUploadFormValidationSchema = yup.object().shape({
  isSubmitted: yup
    .boolean()
    .oneOf([true], "Required"),
  comment: yup
    .string()
    .required("Required")
})

export default function ApplicationEsignList(): JSX.Element {
  const theme = useTheme()

  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [rejectionDialog, setRejectionDialog] = useState(false);
  const [rejectedApplication, setRejectedApplication] = useState<ApplicationProps>();

  const [checkPoaOrNI, setCheckPoaOrNI] = useState(false);
  const [isDialogLoading, setDialogLoading] = useState(false);
  const [id, setId] = useState('');
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [applicationRefsList, setApplicationRefsList] = useState<investmentDetailsAplicationRef[]>(
    []
  );
  const [tooltip, setTooltip] = useState('Click to Copy');
  const [selectedAppId, setSelectedAppId] = useState<string>("")
  const [isResubmitFatcaLoading, setResubmitFatcaLoading] = useState<boolean>(false)
  const [isChequeUploadFormDialogOpen, setChequeUploadFormDialogOpen] = useState<boolean>(false)
  const [isChequeUploadFormSubmitting, setChequeUploadFormSubmitting] = useState<boolean>(false)

  const handleDialogClose = () => {
    setDialogLoading(false);
    setOpen(true);
  };

  useEffect(() => {
    let componentIsAlive = true;
    (async function () {
      try {
        if (id) {
          const responseApplicationRefsList = (await dispatch(
            ApplicationRefs(id)
          )) as unknown as investmentDetailsAplicationRef[];
          if (!componentIsAlive) {
            return;
          }
          setApplicationRefsList(responseApplicationRefsList);
          handleDialogClose();
        }
      } catch (e) {
        setDialogLoading(false);
        console.error((e as Error).message);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, [id]);

  const handleClose = () => {
    setOpen(false), setId('');
  };

  const handleRejectionDialogClose = () => {
    setRejectionDialog(false);
  };

  const openChequeUploadFormDialog = () => {
    setChequeUploadFormDialogOpen(true)
  }

  const closeChequeUploadFormDialog = () => {
    setSelectedAppId("")
    setChequeUploadFormDialogOpen(false)
  }

  const handleChequeUploadFormSubmit = async (values: ChequeUploadFormValues) => {
    try {
      setChequeUploadFormSubmitting(true)

      const payload = {
        isSubmitted: values?.isSubmitted,
        id: Number(selectedAppId ?? ""),
        comment: values?.comment
      }

      const apiResponse = await (dispatch(updateChequeStatus(payload)) as unknown as Promise<UpdateChequeStatusResponseBody>)

      if (apiResponse) {
        closeChequeUploadFormDialog()
        dispatch(showError(apiResponse?.message ?? ""))
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setSelectedAppId("")
      setChequeUploadFormSubmitting(false)
    }
  }

  const handleResubmitFatcaClick = async (selectedId: string) => {
    try {
      setResubmitFatcaLoading(true)
      setSelectedAppId(selectedId)

      const payload = {
        ids: [Number(selectedId)]
      }

      const apiResponse = await (dispatch(resubmitFatca(payload)) as unknown as Promise<Array<ResubmitFatcaResponseBody>>)

      if (apiResponse) {
        dispatch(showError(apiResponse[0]?.response ?? ""))
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setResubmitFatcaLoading(false)
      setSelectedAppId("")
    }
  }

  const resubmitFatcaCell = {
    header: 'Resubmit FATCA',
    renderCell: (row: ApplicationProps) => {
      return (
        <IconButton
          sx={{
            cursor: 'pointer',
            pointerEvents: "all",
            padding: "5px",
            "&: disabled": {
              opacity: 0.5,
              cursor: "not-allowed",
              pointerEvents: "all",
            }
          }}
          onClick={() => handleResubmitFatcaClick(row?.id ?? "")}
          // disabled={
          //   (`${row?.bseClientActivationStatus ?? ""}`.toLowerCase() !== "active") || isResubmitFatcaLoading
          // }
          disabled={isResubmitFatcaLoading}
        >
          {
            ((row?.id === selectedAppId) && isResubmitFatcaLoading) ? (
              <CircularProgress size={20} thickness={2} />
            ) : (
              <Autorenew
                sx={{
                  color: theme.palette.primary[500],
                  ...theme.typography.body_600
                }}
              />
            )
          }
        </IconButton>
      )
    },
  }

  const chequeUploadStatusCell = {
    header: 'Cheque Upload Status',
    renderCell: (row: ApplicationProps) => {
      console.log("row", row)

      // Cheque Upload is enabled only when investor type is Minor/NRE/NRO and bseClientActivationStatus !== active and isBSEEnabled = true and status = completed

      const isChequeUploadEnabled = (
        // Checking if investor type is Minor/NRE/NRO
        (
          // Checking if investor type is Minor
          `${row?.onboardingType ?? ""}`.toLowerCase() === "minor" ||
          // Checking if investor type is NRE/NRO
          (
            `${row?.onboardingType ?? ""}`.toLowerCase() === "normal" &&
            ["nro", "nre"].includes(`${row?.applicants.find(obj => `${obj?.applicant_type ?? ""}` === '1')?.status ?? ""}`.toLowerCase())
          )
        )
        &&
        // Checking if bseClientActivationStatus !== active
        (
          `${row?.bseClientActivationStatus ?? ""}`.toLowerCase() !== "active"
        )
        &&
        // Checking if isBSEEnabled = true
        !!row?.isBSEEnabled
        &&
        //Checking if status = completed
        `${row?.status ?? ""}`.toLowerCase() === "completed"
      )

      return (
        <IconButton
          sx={{
            cursor: 'pointer',
            pointerEvents: "all",
            padding: "8px",
            "&: disabled": {
              opacity: 0.5,
              cursor: "not-allowed",
              pointerEvents: "all",
            }
          }}
          onClick={() => {
            setSelectedAppId(row?.id ?? "")
            openChequeUploadFormDialog()
          }}
          disabled={!isChequeUploadEnabled || isResubmitFatcaLoading}
        >
          <ChatBubbleOutline
            sx={{
              color: theme.palette.primary[500],
              ...theme.typography.body_600
            }}
          />
        </IconButton>
      )
    },
  }

  const rejectionCell = {
    header: '',
    renderCell: (row: ApplicationProps) => {
      return (
        <>
          <Box
            sx={{
              display: 'flex',
            }}>
            {APPLICATION_STATUS[row.status] === 'Rejected' && (
              <IconButton>
                <CardMedia
                  component="img"
                  src="/images/comment.svg"
                  alt="comment"
                  sx={{ width: '20px' }}
                  onClick={() => {
                    setRejectedApplication(row);
                    setRejectionDialog(true);
                  }}
                />
              </IconButton>
            )}
          </Box>
        </>
      );
    },
  };
  const RefCell = {
    header: '',
    renderCell: (row: ApplicationProps) => {
      return (
        <>
          <Box
            sx={{
              display: 'flex',
            }}>
            {USER_ROLES.AMCAPPROVER === role && (
              <>
                {!['draft', 'rejected', 'sent_to_poa_approver', 'sent_to_amc_approver'].includes(
                  row.status
                ) && row?.isEsignEnabled && (
                    <Tooltip title="Link">
                      <IconButton
                        sx={{
                          p: 0,
                          ':hover': {
                            bgcolor: '#F4FCFC',
                          },
                        }}
                        onClick={() => {
                          setId(row.id as string),
                            setDialogLoading(true),
                            setCheckPoaOrNI(row.hasPOA || checkIfApplicationIsNonIndividual(row));
                        }}>
                        <CardMedia
                          component="img"
                          src="/images/link-icon.svg"
                          alt="Link"
                          sx={{ width: '30px' }}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                {row?.signedLeegalityFile?.url && (
                  <Tooltip title={'Download'}>
                    <IconButton
                      sx={{
                        p: 0,
                        pl: 0.5,
                        pr: 0.5,
                        ':hover': {
                          bgcolor: '#F4FCFC',
                        },
                        cursor: 'pointer',
                        pointerEvents: 'all',
                      }}
                      onClick={() =>
                        row?.signedLeegalityFile?.url && window.open(row?.signedLeegalityFile?.url)
                      }>
                      <CardMedia
                        component="img"
                        src={'/images/download-icon.png'}
                        alt="Download"
                      //sx={{ width: '30px' }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
              </>
            )}
          </Box>
        </>
      );
    },
    outerCellStyles: {
      paddingLeft: "10px",
      paddingRight: "30px",
    },
  };
  return (
    <>
      {/* <CommonLayoutForPOA > */}
      <CommonLayout>
        <>
          <ApplicationsListView tableHeaders={[...getTableHeader(role), resubmitFatcaCell, chequeUploadStatusCell, rejectionCell, RefCell]} />
          <Dialog
            onClose={handleClose}
            open={open}
            sx={{
              '.MuiPaper-root ': {
                width: { xs: '70%', sm: '70%' },
              },
            }}>
            <Grid
              item
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              p={4}
              pb={2}>
              <Typography sx={{ color: 'primary.main', fontSize: '20px', fontWeight: 500 }}>
                Get Link
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon fontSize="medium" />
              </IconButton>
            </Grid>
            {applicationRefsList &&
              applicationRefsList.map((ref) => {
                return (
                  <React.Fragment key={ref.id}>
                    <Grid
                      item
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      px={4}
                      py={1}
                      sx={{
                        ':hover': {
                          bgcolor: '#F4FCFC',
                        },
                        ':last-of-type': {
                          mb: 5,
                        },
                      }}>
                      <Typography
                        sx={{
                          color: 'rgba(41, 49, 57, 0.7)',
                          fontSize: '18px',
                          fontWeight: 500,
                        }}>
                        Copy Link For {ref.name}
                      </Typography>
                      <Tooltip title={tooltip}>
                        <IconButton
                          onMouseOver={() => {
                            setTooltip('Copy Link');
                          }}
                          onClick={() => {
                            setTooltip('Copied'),
                              navigator.clipboard.writeText(
                                checkPoaOrNI
                                  ? ref.invitationUrl
                                  : `${window.location.origin}/investment-details/${ref.referenceId}/investor-login`
                              );
                          }}>
                          <CardMedia
                            component="img"
                            src="/images/link-icon.svg"
                            alt="Link"
                            sx={{ width: '35px' }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </React.Fragment>
                );
              })}
          </Dialog>
          <Dialog
            onClose={handleDialogClose}
            open={isDialogLoading}
            sx={{
              '.MuiPaper-root ': {
                p: 4,
                width: { xs: '70%', sm: '70%' },
              },
            }}>
            <Box
              sx={{
                width: { xs: '100%', sm: '80%' },
                mx: 'auto',
                '.MuiTypography-root': {
                  fontSize: 20,
                  fontWeight: 500,
                },
              }}>
              <Typography sx={{ color: 'primary.main', lineHeight: '35px', textAlign: 'center' }}>
                Loading...
              </Typography>
            </Box>
          </Dialog>

          <Dialog
            onClose={handleRejectionDialogClose}
            open={rejectionDialog}
            sx={{
              '.MuiPaper-root ': {
                width: { xs: '70%', sm: '70%' },
              },
            }}>
            <IconButton
              onClick={handleRejectionDialogClose}
              sx={{ alignSelf: 'flex-end', mt: 2, mr: 2 }}>
              <CloseIcon fontSize="medium" />
            </IconButton>
            {rejectedApplication && (
              <Box
                sx={{
                  width: { xs: '80%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontWeight: 500,
                  },
                  mt: 1,
                  mb: 5,
                }}>
                <Typography
                  sx={{
                    color: 'primary.main',
                    fontSize: '18px',
                    letterSpacing: '0.4px',
                    ml: { sm: 6.7 },
                    mt: 1,
                  }}>
                  Application Id:{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#337FC9',
                      fontSize: '16px',
                      letterSpacing: '0.4px',
                      ml: 0.5,
                    }}>
                    {rejectedApplication.applicationNumber}
                  </Typography>
                </Typography>
                <Typography
                  sx={{
                    color: 'primary.main',
                    fontSize: '18px',
                    letterSpacing: '0.4px',
                    ml: { sm: 1.5 },
                    mt: 1,
                  }}>
                  Application Status:{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#BD2932',
                      fontSize: '16px',
                      letterSpacing: '0.4px',
                      ml: 0.5,
                    }}>
                    {POA_APPLICATION_STATUS[rejectedApplication.status]}
                  </Typography>
                </Typography>
                <Typography
                  sx={{
                    color: 'primary.main',
                    fontSize: '18px',
                    letterSpacing: '0.4px',
                    ml: { sm: 9 },
                    mt: 1,
                  }}>
                  Rejected on:{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#337FC9',
                      fontSize: '16px',
                      letterSpacing: '0.4px',
                      ml: 0.5,
                    }}>
                    {/* {formatShortDateAndTime(rejectedApplication.rejectedAt)} */}
                    {dayjs(rejectedApplication?.rejectedAt).format('DD MMM YY h:mm A')}
                  </Typography>
                </Typography>
                <Typography
                  sx={{
                    color: 'primary.main',
                    fontSize: '18px',
                    letterSpacing: '0.4px',
                    ml: { sm: 9.5 },
                    mt: 1,
                  }}>
                  Rejected by:{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#337FC9',
                      fontSize: '16px',
                      letterSpacing: '0.4px',
                      ml: 0.5,
                    }}>
                    {/* {REJECTED_ROLES[rejectedApplication.rejectedByRole]} */}
                    {rejectedApplication?.rejectedBy}
                  </Typography>
                </Typography>
                <Typography
                  sx={{
                    color: 'primary.main',
                    fontSize: '18px',
                    letterSpacing: '0.4px',
                    mt: 1,
                  }}>
                  Reason for rejection:{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#337FC9',
                      fontSize: '16px',
                      letterSpacing: '0.4px',
                      ml: 0.5,
                    }}>
                    {rejectedApplication.rejectedReason}
                  </Typography>
                </Typography>
                <Button
                  variant="contained"
                  sx={{ ml: '32%', lineHeight: 1.1, width: '30%', mt: 3 }}
                  onClick={handleRejectionDialogClose}>
                  Done
                </Button>
              </Box >
            )
            }
          </Dialog >
          {/* <Footer /> */}

          {/* Cheque Upload Form Dialog Start */}
          <Dialog
            onClose={isChequeUploadFormSubmitting ? undefined : closeChequeUploadFormDialog}
            open={isChequeUploadFormDialogOpen}
            maxWidth='md'
            fullWidth
            sx={(theme: Theme) => ({
              '& .MuiPaper-root': {
                borderRadius: '25px',
                backgroundColor: theme.palette.common.white,
                padding: "25px",
                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
              },
            })}
          >
            <Formik
              validationSchema={chequeUploadFormValidationSchema}
              initialValues={chequeUploadFormInitialValues}
              onSubmit={handleChequeUploadFormSubmit}
            >
              {({ values, setFieldValue }) => {
                return (
                  <Form>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "5px"
                      }}
                    >
                      <Typography
                        variant='h2'
                      >
                        Cheque Upload Status
                      </Typography>
                      <Typography
                        variant='subtitle_500'
                        sx={(theme: Theme) => ({
                          color: theme.palette.text.secondary
                        })}
                      >
                        Below fields once updated cannot be changed
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "20px"
                      }}
                    >
                      <MFCheckbox
                        name="isSubmitted"
                        label="Cheque status active in BSE portal *"
                        checked={values.isSubmitted}
                        sx={{ letterSpacing: '1px' }}
                        disabled={isChequeUploadFormSubmitting}
                      />
                      <MFTextField
                        name="comment"
                        label="Remarks *"
                        placeholder=""
                        multiline
                        value={values?.comment ?? ""}
                        onBlur={({ target: { value } }) => setFieldValue("comment", `${value ?? ""}`.trim())}
                        disabled={isChequeUploadFormSubmitting}
                      />
                    </Box>
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      loading={isChequeUploadFormSubmitting}
                      loadingPosition="center"
                      sx={(theme: Theme) => ({
                        ...theme.typography.body_500,
                        fontWeight: 700,
                        lineHeight: "22.5px",
                        letterSpacing: "0.02px",
                        color: theme.palette.textDark.primary,
                        borderRadius: "10px",
                        padding: "13px 56px",
                        boxShadow: "none",
                        backgroundColor: theme.palette.primary[500],
                        marginTop: "10px"
                      })}
                    >
                      Submit
                    </LoadingButton>
                  </Form>
                )
              }}
            </Formik>
          </Dialog>
          {/* Cheque Upload Form Dialog End */}
        </>
      </CommonLayout>
      {/* </CommonLayoutForPOA > */}
    </>
  );
}
